import React from "react";
import { useNavigate } from "react-router-dom";
import { Factory, ArrowRight, Info, ClipboardList } from "lucide-react";
import { PageHeader, Panel } from "../lib/ui";
import { Button } from "../components/ui/button";

const Crumb = () => <div className="text-[11px] uppercase tracking-wide text-wmuted mb-1">Sales / Pre-Order / Kebutuhan Produksi</div>;

export default function PreOrderProduction() {
  const navigate = useNavigate();
  return (
    <div className="space-y-4" data-testid="preorder-production-page">
      <div><Crumb />
        <PageHeader title="Kebutuhan Produksi" subtitle="Tautan ke perencanaan & permintaan produksi existing untuk memenuhi pesanan PO." />
      </div>
      <Panel className="p-5" data-testid="po-prod-info">
        <div className="flex items-start gap-3">
          <Info className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
          <div className="text-sm text-cocoa space-y-2">
            <p className="font-medium">Belum ada agregasi kebutuhan produksi khusus PO di backend.</p>
            <p className="text-wmuted">Untuk menjaga akurasi, halaman ini tidak menghitung sendiri angka kekurangan/alokasi WIP (agar tidak menampilkan nol yang menyesatkan). Gunakan modul produksi existing yang sudah memiliki perhitungan resmi:</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
          <button onClick={() => navigate("/production/plans")} data-testid="po-prod-goto-planning" className="flex items-center justify-between p-4 rounded-lg border border-taupe/30 hover:border-cocoa/50 bg-white text-left">
            <span className="flex items-center gap-2 text-cocoa"><Factory className="w-4 h-4" />Production Planning</span>
            <ArrowRight className="w-4 h-4 text-blue-600" />
          </button>
          <button onClick={() => navigate("/inventory/forecast")} data-testid="po-prod-goto-forecast" className="flex items-center justify-between p-4 rounded-lg border border-taupe/30 hover:border-cocoa/50 bg-white text-left">
            <span className="flex items-center gap-2 text-cocoa"><ClipboardList className="w-4 h-4" />Stock Prediction / Restock</span>
            <ArrowRight className="w-4 h-4 text-blue-600" />
          </button>
        </div>
        <p className="text-xs text-wmuted mt-4">Catatan ketergantungan: agregasi "kebutuhan produksi per pesanan PO" (mockup) memerlukan endpoint backend baru dan perhitungan bisnis — di luar scope refactor UI ini.</p>
      </Panel>
    </div>
  );
}
